import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Box } from '../Box/Box.mjs';

const ModalBodyWrapper = styled(Box) `
  overflow: auto;
  max-height: 60vh;
`;
const ModalBody = (props) => {
    return jsx(ModalBodyWrapper, { padding: 7, ...props });
};

export { ModalBody };
